module.exports = __webpack_public_path__ + "media/images/apple-icon-114x114-a0744a22.png";